module.exports = __webpack_public_path__ + "static/img/Bachelor_010403.77ab193.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010403.jpg
// module id = 160
// module chunks = 0